import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Route, Routes, useNavigate, useLocation, } from "react-router-dom";
import { useSelector } from "react-redux";
import Auth from "../modules/auth";
import Home from "../modules/home";
import SiteOnBoard from "../modules/SiteOnboard/SiteOnboard";
import NoAuth from "../modules/noAuth";
import ProtectedRouter from "./protectedRouter";
import CreateBuilding from "../../src/modules/building/baseFileUpload";
import Wrapper from "../../src/components/layouts/Wrapper";
import Align from '../../src/modules/Georeference/georeference';
import Editor from "../modules/editor";
import AlignFloors from "../../src/modules/alignment";
import ApiKey from "../modules/apiKey/apiKey";
import SiteListPage from '../modules/sites/SiteListPage';
import OrganisationListPage from '../modules/organisation/OrganisationListPage';
import FeedbackPage from '../modules/feedback/FeedbackPage';
import VisitorsPage from '../modules/visitors/VisitorsPage';
const AuthCheck = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = useSelector((state) => state?.auth?.userLogin?.response?.data?.accessToken);
    const [isChecking, setIsChecking] = React.useState(true);
    useEffect(() => {
        // If token exists and we're on the home page or authentication page, redirect to site-list
        if (token && (location.pathname === '/')) {
            navigate('/site-list', { replace: true });
            return;
        }
        // If checking and no redirect is needed, allow rendering
        setIsChecking(false);
    }, [token, location.pathname, navigate]);
    // Show loading or nothing while checking for token
    if (isChecking && token && (location.pathname === '/')) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
const Routers = () => {
    return (_jsx(AuthCheck, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/no-auth", element: _jsx(NoAuth, {}) }), _jsx(Route, { path: "/authentication", element: _jsx(Auth, {}) }), _jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/organisations", element: _jsx(OrganisationListPage, {}) }), _jsxs(Route, { element: _jsx(ProtectedRouter, { layout: Wrapper }), children: [_jsx(Route, { path: "/site-list", element: _jsx(SiteListPage, {}) }), _jsx(Route, { path: "/create-site", element: _jsx(SiteOnBoard, {}) }), _jsx(Route, { path: "/building", element: _jsx(CreateBuilding, {}) }), _jsx(Route, { path: "/floor-align", element: _jsx(AlignFloors, {}) }), _jsx(Route, { path: "align", element: _jsx(Align, {}) }), _jsx(Route, { path: "/api-key", element: _jsx(ApiKey, {}) }), _jsx(Route, { path: "/feedbacks", element: _jsx(FeedbackPage, {}) }), _jsx(Route, { path: "/visitors", element: _jsx(VisitorsPage, {}) })] }), _jsx(Route, { path: "/editor", element: _jsx(Editor, {}) })] }) }));
};
export default Routers;
